import React from "react";
import { CUSTOM_INTEREST } from "@irati/insights/constants/interest";
import EmployeeEngagementPulseSurvey from "@irati-web/insights/images/aoiImages/EmployeeEngagementPulseSurvey.svg";
import CustomPulseSurvey from "@irati-web/insights/images/aoiImages/CustomSurvey.svg";
import { FormattedMessage } from "@irati/utils/lang";
import { CardWrapper, ImageWrapper, TitleWrapper, PillBadgeWrapper } from "./styled";
var areaOfInterestRenderer = function (AoIOptionRow) {
    var option = AoIOptionRow.option, checked = AoIOptionRow.checked;
    var idNamespace = "AreaOfInterestRenderer";
    var titleId = option.contentId + ".title";
    var contentId = option.contentId + ".tag";
    return (React.createElement(CardWrapper, { id: idNamespace, checked: checked },
        React.createElement(ImageWrapper, { src: option.contentId === CUSTOM_INTEREST ? CustomPulseSurvey : EmployeeEngagementPulseSurvey }),
        React.createElement(TitleWrapper, null,
            React.createElement(FormattedMessage, { id: titleId })),
        React.createElement(PillBadgeWrapper, null,
            React.createElement(FormattedMessage, { id: contentId }))));
};
export default areaOfInterestRenderer;
